import axios from '@/server/request'

const state = {
    // 顶部数据
    topData: {},
    // 热门文章
    isHotArticleLoading: true,
    hotArticleData: {},
    // 我的订阅
    isSubscriptionLoading: true,
    subscriptionData: {},
    // 最新政策
    isPolicyLoading: true,
    policyData: {},
    // 事件列表
    isEventLoading: true,
    eventData: {},
    // 热门房产
    isHotAccountLoading: true,
    hotAccountOptions: [],
    // 专题数据
    subjectData: {},

    // 企业动态
    isDynamicLoading: true,
    dynamicData: {}
}

const mutations = {
    updateTop(state, payload) {
        state.topData = null
        state.topData = payload
    },

    updateHotArticle(state, payload) {
        state.hotArticleData = {}
        state.hotArticleData = payload
    },

    updateHotArticleLoading(state, payload) {
        state.isHotArticleLoading = payload
    },

    updateSubscription(state, payload) {
        state.subscriptionData = {}
        state.subscriptionData = payload
    },

    updateSubscriptionLoading(state, payload) {
        state.isSubscriptionLoading = payload
    },

    updatePolicy(state, payload) {
        state.policyData = null
        state.policyData = payload
    },

    updatePolicyLoading(state, payload) {
        state.isPolicyLoading = payload
    },

    updateEvent(state, payload) {
        state.eventData = null
        state.eventData = payload
    },

    updateEventLoading(state, payload) {
        state.isEventLoading = payload
    },

    updateHotAccount(state, payload) {
        state.hotAccountOptions.splice(0)
        state.hotAccountOptions = payload
    },

    updateHotAccountLoading(state, payload) {
        state.isHotAccountLoading = payload
    },

    updateSubject(state, payload) {
        state.subjectData = null
        state.subjectData = payload
    },

    updataDynamicData(state, payload) {
        state.dynamicData = null
        state.dynamicData = payload
    },

    updateDynamicLoading(state, payload) {
        state.isDynamicLoading = payload
    }

}

const actions = {
    /**
     * 顶部数据
     */
    async fetchTop({ commit }, params) {
        try {
            const res = await axios.get({
                url: '/Home/calendarHot',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateTop', res.data.Data)
            }
        } catch (errMsg) {
            console.error(errMsg)
        }
    },

    /**
     * 热门文章
     */
    async fetchHotArticle({ commit }, params) {
        commit('updateHotArticleLoading', true)
        try {
            const res = await axios.post({
                url: '/Home/hotArticle',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateHotArticle', res.data.Data)
                commit('updateHotArticleLoading', false)
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateHotArticleLoading', false)
        }
    },

    /**
     * 我的订阅
     */
    async fetchSubscription({ commit }, params) {
        commit('updateSubscriptionLoading', true)
        try {
            const res = await axios.post({
                url: '/Home/mySubscribe',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateSubscription', res.data.Data)
                commit('updateSubscriptionLoading', false)
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateSubscriptionLoading', false)
        }
    },

    /**
     * 最新政策
     */
    async fetchPolicy({ commit }, params) {
        commit('updatePolicyLoading', true)
        try {
            const res = await axios.get({
                // url: '/Home/newZhengce',
                url: '/Policy/homePolicy',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updatePolicy', res.data.Data)
                commit('updatePolicyLoading', false)
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updatePolicyLoading', false)
        }
    },

    /**
     * 事件列表
     */
    async fetchEvent({ commit }, params) {
        commit('updateEventLoading', true)
        try {
            const res = await axios.get({
                url: '/Home/hotEvent',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateEvent', res.data.Data)
                commit('updateEventLoading', false)
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateEventLoading', false)
        }
    },

    /**
     * 热门房产
     */
    async fetchHotAccount({ commit }, params) {
        commit('updateHotAccountLoading', true)
        try {
            const res = await axios.get({
                url: '/Home/fangchanTop',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateHotAccount', res.data.Data)
                commit('updateHotAccountLoading', false)
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateHotAccountLoading', false)
        }
    },

    /**
     * 主题数据
     */
    async fetchSubject({ commit }, params) {
        try {
            const res = await axios.get({
                url: '/Home/getSpecialInfo',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateSubject', res.data.Data)
            }
        } catch (errMsg) {
            console.error(errMsg)
        }
    },

    /**
     * 企业动态数据
     */
    async fetchDynamic({ commit }, params) {
        commit('updateDynamicLoading', true)
        try {
            const res = await axios.get({
                url: '/Home/getEnterpriseList',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updataDynamicData', res.data.Data)
                commit('updateDynamicLoading', false)
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateDynamicLoading', false)
        }
    }

}

export default {
    namespaced: true,
    state,
    getters: {},
    mutations,
    actions
}
